import { z } from 'zod'

export const createUserSchema = z.object({
  username: z.string().min(1, 'Benutzername ist erforderlich'),
  password: z.string().min(8, 'Mindestens 8 Zeichen'),
  name: z.string().min(1, 'Name ist erforderlich'),
  email: z.string().email('Ungueltige E-Mail-Adresse').or(z.literal('')).optional(),
  phone: z.string().optional(),
  role: z.enum(['admin', 'bauleiter', 'mitarbeiter'], { required_error: 'Rolle ist erforderlich' }),
})

export type CreateUserInput = z.infer<typeof createUserSchema>

export const editUserSchema = z.object({
  username: z.string().min(1, 'Benutzername ist erforderlich'),
  name: z.string().min(1, 'Name ist erforderlich'),
  email: z.string().email('Ungueltige E-Mail-Adresse').or(z.literal('')).optional(),
  phone: z.string().optional(),
  birthdate: z.string().optional(),
  role: z.enum(['admin', 'bauleiter', 'mitarbeiter']),
  is_active: z.boolean(),
  user_status: z.string(),
  exit_date: z.string().optional(),
  show_in_overview: z.boolean(),
  webui_access: z.boolean(),
  personal_number: z.string().optional(),
  employment_type: z.string(),
  vacation_days_total: z.coerce.number().min(0, 'Muss >= 0 sein'),
  vacation_days_remaining: z.coerce.number(),
  vacation_days_carried: z.coerce.number().min(0, 'Muss >= 0 sein'),
  work_start_time: z.string(),
  work_end_time: z.string(),
  default_break_minutes: z.coerce.number().min(0, 'Muss >= 0 sein'),
})

export type EditUserInput = z.infer<typeof editUserSchema>

export const resetPasswordSchema = z.object({
  password: z.string().min(8, 'Mindestens 8 Zeichen'),
})

export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>

export const loginSchema = z.object({
  username: z.string().min(1, 'Benutzername ist erforderlich'),
  password: z.string().min(1, 'Passwort ist erforderlich'),
})

export type LoginInput = z.infer<typeof loginSchema>
